<template>
  <v-form :disabled="!isEditBtn" ref="form" v-model="valid" class="container">
    <div class="main-block__wrapper">
      <div class="mt-10 block-2-cols">
        <div class="left-col column">
            <div class="form-block__wrapper patient-form">
              <p class="font-weight-medium block-title ma-0 text-center">
                {{ $vuetify.lang.t("$vuetify.main.patientDashboard.settings.title") }}
              </p>
              <div class="form-block">
                <div class="d-flex align-baseline">
                  <v-text-field
                    required
                    v-model="patientName"
                    :rules="patientNameRules"
                    :label="
                      $vuetify.lang.t(`$vuetify.main.patientDashboard.settings.name`)
                    "
                    value=""
                    outlined
                  ></v-text-field>
                </div>
                <div class="d-flex align-baseline">
                  <v-text-field
                    required
                    v-model="patientAge"
                    :rules="patientAgeRules"
                    :label="
                      $vuetify.lang.t(`$vuetify.main.patientDashboard.settings.age`)
                    "
                    outlined
                  ></v-text-field>
                </div>
              </div>

              <!-- <p class="font-weight-medium title ma-0">
                {{
                  $vuetify.lang.t("$vuetify.main.patientDashboard.settings.contacts")
                }}
              </p> -->
              <div class="d-flex align-baseline">
                  <vue-phone-number-input
                    :disabled="!isEditBtn"
                    v-model="userPhoneNumber"
                    :loader="hasLoaderActive"
                    :error="hasErrorActive"
                    :default-country-code="defaultCountry"
                    :preferred-countries="countriesList"
                    show-code-on-list
                    required
                    @update="updatedData"
                    :translations="translations"
                  />
                  <!-- <v-checkbox
                    v-model="patientNotificationPerHourOnPhone"
                    :label="
                      $vuetify.lang.t(
                        `$vuetify.main.patientDashboard.settings.smsNotification`
                      )
                    "
                  ></v-checkbox> -->
              </div>
              <div class="inputfield-margin-top">
                  
                    <TimeZOneInput
                        @new-time-zone="setNewTimeZOne"
                        :default-value="timezone"
                        :isOutlined="true"
                        :label="
                          $vuetify.lang.t(
                            `$vuetify.main.patientReg.stepOne.timeZone`
                          )
                        "
                        :is-dense="false"
                      ></TimeZOneInput>
              </div>
              <div class="">
                  <v-text-field
                    v-model="patientEmail"
                    :rules="patientEmailRules"
                    label="Email"
                    :placeholder="this.$store.getters['user/getUser'].email"
                    required
                    outlined
                  ></v-text-field>

                  <v-checkbox
                    class="pt-0 mt-0"
                    v-model="patientNotificationBlog"
                    :label="
                      $vuetify.lang.t(
                        `$vuetify.main.patientDashboard.settings.blogLabel`
                      )
                    "
                  ></v-checkbox>
                  <!-- <v-row class="d-flex align-center pl-3">
                    <v-checkbox
                      class="pt-0 mt-0"
                      v-model="patientNotificationOnEmailChecked"
                      :label="
                        $vuetify.lang.t(
                          `$vuetify.main.patientDashboard.settings.notificationLabel`
                        )
                      "
                    ></v-checkbox>
                    <v-col md="4">
                      <v-select
                        :disabled="!patientNotificationOnEmailChecked"
                        :items="items"
                        item-value="id"
                        item-text="title"
                        v-model="patientNotificationOnEmailPerDynamicTime"
                        :label="
                          $vuetify.lang.t(
                            `$vuetify.main.patientDashboard.settings.timeLabel`
                          )
                        "
                        outlined
                      ></v-select>
                    </v-col>
                    <p
                      class="align-self-center text--secondary"
                      :class="{ 'text--disabled': !isEditBtn }"
                    >
                      {{
                        $vuetify.lang.t(
                          `$vuetify.main.patientDashboard.settings.beforeSession`
                        )
                      }}
                    </p>
                  </v-row> -->
              </div>
              <div class="d-flex justify-end">
                <v-btn
                  @click="validate"
                  v-if="isEditBtn"
                  depressed
                  color="primary"
                  class="mb-2"
                >
                  {{
                    $vuetify.lang.t(`$vuetify.main.patientDashboard.settings.save`)
                  }}
                </v-btn>

                <v-btn
                  @click="isEditBtn = !isEditBtn"
                  v-if="!isEditBtn"
                  depressed
                  color="warning"
                  class="mb-2"
                >
                  {{
                    $vuetify.lang.t(`$vuetify.main.patientDashboard.settings.refresh`)
                  }}
                </v-btn>
              </div>
              <div class="social-logins-wrapper" v-if="!loginProviders || !loginProviders.length || !loginProviders.some(provider => provider.login_provider === 'google') || !loginProviders.some(provider => provider.login_provider === 'apple')">
                <br>
                <div v-if="!loginProviders || !loginProviders.length || !loginProviders.some(provider => provider.login_provider === 'google')">
                  <login-with-google :clickFunc="login" :isLinking="true" />
                </div>
                <div v-if="!loginProviders || !loginProviders.length || !loginProviders.some(provider => provider.login_provider === 'apple')">
                  <login-with-apple :clickFunc="loginWithApple" :isLinking="true" />
                </div>
              </div>
            </div>
        </div>
        <!-- <v-col cols="12" md="2">
          </v-col> -->
        <div class="right-col column">
          <InteractivePaymentCard v-if="$store.getters['settings/clientPaymentsEnabled']" class="mb-10"></InteractivePaymentCard>
          <div class="info-block">
            <div class="qr-code__wrapper">
              <a href="https://platforma-life-bot.tg.pulse.is" target="_blank" rel="noopener" class="qr-code" aria-label="@PLATFORMA_LIFE_BOT"></a>
              <div class="bot-nickname text-colored">
                <a href="https://platforma-life-bot.tg.pulse.is" target="_blank" rel="noopener">@PLATFORMA_LIFE_BOT</a>
              </div>
            </div>
            <div class="info-text">
              {{
                $vuetify.lang.t(`$vuetify.main.patientDashboard.settings.infoText1`)
              }}
              <a href="https://platforma-life-bot.tg.pulse.is" target="_blank" rel="noopener">Telegram-бот</a>,
              {{
                $vuetify.lang.t(`$vuetify.main.patientDashboard.settings.infoText2`)
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-form>
</template>

<script>
const LoginWithGoogle = () => import("@/components/UI/LoginWithGoogle");
const LoginWithApple = () => import("@/components/UI/LoginWithApple");
import { mapGetters } from "vuex";
import InteractivePaymentCard from "./Interactive-payment-card/InteractivePaymentCard";
//import Vue from "vue";
const TimeZOneInput = () => import("../../../components/UI/timeZoneInput");

export default {
  name: "patientSettings",
  components: { 
    TimeZOneInput,
    InteractivePaymentCard,
    LoginWithGoogle, 
    LoginWithApple 
  },
  metaInfo() {
    return {
      title:
        "Платформа / " +
        this.$vuetify.lang.t("$vuetify.main.header.menu.settings"),
    };
  },
  data() {
    return {
      loginProviders: [],
      timezone: "",
      valid: true,
      loader: null,
      loading: false,
      isEditBtn: true,
      patientName: null,
      patientAge: null,
      patientEmail: null,
      patientNotificationPerHourOnPhone: false,
      patientNotificationBlog: false,
      patientNotificationPerHoursOnEmail: false,
      patientNotificationOnEmailPerDynamicTime: "",
      patientNotificationOnEmailChecked: false,
      patientNameRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.patientReg.stepOne.patientNameRules"
          ),
      ],
      patientAgeRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.patientReg.stepOne.patientAgeRules1"
          ),
        (v) =>
          +v > 16 ||
          this.$vuetify.lang.t(
            "$vuetify.main.patientReg.stepOne.patientAgeRules2"
          ),
      ],
      patientEmailRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.patientReg.stepOne.patientEmailRules1"
          ),
        (v) =>
          /.+@.+/.test(v) ||
          this.$vuetify.lang.t(
            "$vuetify.main.patientReg.stepOne.patientEmailRules2"
          ),
      ],
      items: [
        {
          id: 1,
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.settings.notificationLabel.1"
          ),
        },
        {
          id: 2,
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.settings.notificationLabel.2"
          ),
        },
        {
          id: 5,
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.settings.notificationLabel.5"
          ),
        },
        {
          id: 12,
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.settings.notificationLabel.12"
          ),
        },
        {
          id: 24,
          title: this.$vuetify.lang.t(
            "$vuetify.main.psychologistDashboard.settings.notificationLabel.24"
          ),
        },
      ],
      userPhoneNumber: null,
      defaultCountry: "",
      countriesList: ["UA", "RU", "BY", "MD"],
      hasLoaderActive: false,
      hasErrorActive: false,
      userData: {},
    };
  },
  watch: {
    userData() {
      let countryCode = this.userData.countryCode;
      let nationalNumber = this.userData.nationalNumber;

      switch (countryCode) {
        case "UA":
          if (nationalNumber) {
            if (Array.from(nationalNumber).length > 9) {
              this.hasErrorActive = true;
              this.userData.isValid = false;
            } else {
              this.hasErrorActive = false;
            }
          }
      }
    },
  },
  computed: {
    ...mapGetters({
      user: "user/getUser",
    }),
    translations() {
      return {
        countrySelectorLabel: this.$vuetify.lang.t(
          "$vuetify.view.signIn.countrySelectorLabel"
        ),
        countrySelectorError: this.$vuetify.lang.t(
          "$vuetify.view.signIn.countrySelectorError"
        ),
        phoneNumberLabel: this.$vuetify.lang.t(
          "$vuetify.view.signIn.phoneNumberLabel"
        ),
        example: this.$vuetify.lang.t("$vuetify.view.signIn.example"),
      };
    },
  },
  beforeCreate() {
    this.$store.dispatch("user/getProfile", {});
  },
  beforeMount() {
    this.timezone = this.user.timezone;

    this.loginProviders = this.user.login_providers;

    this.patientName = this.user.name;

    this.patientAge = this.user.age;

    this.patientEmail = this.user.email;

    this.userPhoneNumber = this.user.phone;

    this.defaultCountry = this.user.phone_country_code;

    this.patientNotificationPerHourOnPhone =
      this.user.setting_sms_before_session;

    this.patientNotificationBlog = this.user.setting_subscribed_mailings;

    this.patientNotificationOnEmailChecked =
      this.user.setting_email_before_session;

    this.patientNotificationOnEmailPerDynamicTime =
      this.user.setting_email_before_session_hours_value;
  },
  methods: {
    setNewTimeZOne(newTimeZone) {
      this.timezone = newTimeZone;
    },
    loginWithApple() {
      this.$store.commit("user/SET_PROCESS_LINKING_LOGIN", true);

      let base = process.env.VUE_APP_API.replace(/\/+$/, '');
      window.location.href = `${base}/api/auth/login/apple`;
    },
    login() {
      this.$store.commit("user/SET_PROCESS_LINKING_LOGIN", true);

      let base = process.env.VUE_APP_API.replace(/\/+$/, '');
      window.location.href = `${base}/api/auth/login/google`;
      /* window.google.accounts.oauth2.initTokenClient({
        client_id: process.env.VUE_APP_GOOGLE_OAUTH2_CLIENT_ID,
        scope: "openid email profile",
        callback: (resp) => {
          let payload = {
            provider: 'google',
            token: resp.access_token,
          };
          this.loader = "loading";
          this.$store
            .dispatch('user/linkLogin', JSON.stringify(payload))
            // eslint-disable-next-line no-unused-vars
            .then((response) => {
              if (response.status === 200) {
                this.$router.go(0);
                Vue.swal({
                  target: document.getElementById("main"),
                  text: response.data.message,
                  icon: "success",
                  timer: 4000,
                  toast: true,
                  position: "top-right",
                  showConfirmButton: false,
                });
                this.$store.commit("user/SET_ADMIN_TRIGGER", false);
              }
            })
            .catch((error) => {
              if (error instanceof TypeError) {
                Vue.swal({
                  target: document.getElementById("main"),
                  text: this.$vuetify.lang.t(
                    "$vuetify.view.restore.error"
                  ),
                  icon: "error",
                  timer: 4000,
                  toast: true,
                  position: "top-right",
                  showConfirmButton: false,
                });
              }
              
              if (error.error === "user_exists") {
                Vue.swal({
                  target: document.getElementById("main"),
                  text: this.$vuetify.lang.t(
                    "$vuetify.view.restore.user_exists"
                  ),
                  icon: "error",
                  timer: 4000,
                  toast: true,
                  position: "top-right",
                  showConfirmButton: false,
                });
              }
            })
            .finally(() => {
              this.loader = false;
            });
        }
      }).requestAccessToken(); */
    },
    async updateUserSetting() {
      let payload = {
        phone: this.userData.formattedNumber,
        phone_country_code: this.userData.countryCode,
        email: this.patientEmail,
        questionnaire: {
          timezone: this.timezone,
          setting_subscribed_mailings: +this.patientNotificationBlog,
          setting_sms_before_session: +this.patientNotificationPerHourOnPhone,
          setting_email_before_session_hours:
            this.patientNotificationOnEmailPerDynamicTime,
          setting_email_before_session: +this.patientNotificationOnEmailChecked,
          name: this.patientName,
          age: this.patientAge,
        },
      };
      if (this.userData.isValid === undefined || this.userData.isValid) {
        await this.$store.dispatch(
          "user/updateProfile",
          JSON.stringify(payload)
        );
      }
    },
    updatedData(data) {
      this.userData = data;
    },
    validate() {
      !this.userData.isValid ? this.$refs.form.validate() : this.hasErrorActive;
      // this.valid ? (this.isEditBtn = !this.isEditBtn) : this.valid;

      this.updateUserSetting();

      if (this.userData.isValid !== undefined) {
        this.hasErrorActive = !this.userData.isValid;
      }
    },
  },
};
</script>

<style scoped>
::v-deep .is-valid .country-selector__label,
::v-deep .input-tel.is-valid .input-tel__label {
  color: rgba(0, 0, 0, 0.38) !important;
}

::v-deep .is-valid .country-selector__input,
::v-deep .input-tel.is-valid .input-tel__input {
  border-color: rgba(0, 0, 0, 0.38) !important;
}

::v-deep .country-selector__input,
::v-deep .input-tel .input-tel__input {
  font-size: 16px;
}

::v-deep .country-selector.input-country-selector {
  height: 56px;
}

::v-deep .country-selector .country-selector__input {
  height: 56px;
}

::v-deep .vue-phone-number-input .input-tel {
  height: 56px;
}

::v-deep .input-tel .input-tel__input {
    height: 56px !important;
}

::v-deep .vue-phone-number-input .country-selector__country-flag {
  top: 27px;
}

::v-deep .vue-phone-number-input .country-selector__toggle {
  top: calc(50% - 7px);
}

.main-block__wrapper {
  max-width: 1200px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.block-2-cols {
  display: flex;
  column-gap: 60px;
  justify-content: space-between;
}

.block-2-cols > .column {
  width:100%;
  max-width: 450px;
}

@media screen and (max-width: 960px) {
  .block-2-cols {
    flex-direction: column;
    row-gap: 60px;
  }

  .block-2-cols > .column {
    margin-left: auto;
    margin-right: auto;
  }
}

.block-title {
  font-size: 25px;
  color: #00A3B7;
}
.form-block {
  margin-top: 30px;
}
.inputfield-margin-top {
  margin-top: 28px;
}
/* room between the last button and the footer */
.patient-form {
  padding-bottom: 60px;
}
.form-block__wrapper {
  width: 100%;
  max-width: 450px;
  margin: auto;
}

.qr-code {
  display: block;
  width: 150px;
  height: 150px;
  background-image: url(~@/assets/images/qr-code.jpg);
  background-size: cover;
  background-position: center;
  border: 1.5px solid #00A3B7;
  border-radius: 15px;
}

.qr-code__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* QR of the bot and the text under it, in the right column as in the design */
.info-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 60px;
  margin-top: 90px;
}

@media screen and (max-width: 960px) {
  .info-block {
    margin-top: 0;
    margin-bottom: 40px;
    row-gap: 30px;
  }
}

.info-text {
  max-width: 460px;
  font-size: 20px;
}

.info-text a {
  text-decoration: none;
}

.text-colored {
  color: #00A3B7;
}

.bot-nickname {
  font-size: 11.4px;
  margin-top: 10px;
}

.bot-nickname a {
  text-decoration: none;
}
</style>
